import { create } from 'zustand';
import type { Me } from '@/api/endpoints/me';

interface EntitlementsState {
  me: Me | null;
  enabled: Set<string>;
  setMe: (me: Me) => void;
  isEnabled: (key: string) => boolean;
}

export const useEntitlements = create<EntitlementsState>((set, get) => ({
  me: null,
  enabled: new Set(),
  setMe: (me) =>
    set({ me, enabled: new Set(me.modules.filter((m) => m.habilitado).map((m) => m.key)) }),
  // Antes de carregar (me === null), libera tudo para não piscar/ocultar indevidamente.
  isEnabled: (key) => {
    const s = get();
    return s.me === null ? true : s.enabled.has(key);
  },
}));

/** Converte #RRGGBB em "H S% L%" (formato usado pelas CSS vars do Tailwind). */
export function hexToHslTriplet(hex: string): string | null {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0;
  const l = (max + min) / 2;
  const d = max - min;
  const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  if (d !== 0) {
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
    if (h < 0) h += 360;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}
